import { useState } from 'react';

interface PrecisionNumberInputProps {
  value: number;
  onChange: (value: number) => void;
  className?: string;
}

export function PrecisionNumberInput({
  value,
  onChange,
  className = 'h-7 rounded-md w-full border border-white/12 bg-[#0d1928e6] px-2 text-[0.72rem] text-white outline-none transition-colors focus:border-white/30',
}: PrecisionNumberInputProps) {
  const [isEditing, setIsEditing] = useState(false);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
      return;
    }

    event.preventDefault();

    const direction = event.key === 'ArrowUp' ? 1 : -1;
    let step = 1;

    if (event.shiftKey) {
      step = 0.01;
    } else if (event.altKey) {
      step = 0.0001;
    }

    const nextValue = value + direction * step;
    const rounded = Math.round(nextValue * 10000) / 10000;
    onChange(rounded);
  };

  return (
    <input
      className={className}
      type="number"
      value={value}
      onChange={event => {
        const nextValue = Number.parseFloat(event.target.value);
        if (!Number.isNaN(nextValue)) {
          onChange(nextValue);
        }
      }}
      onKeyDown={handleKeyDown}
      onFocus={() => setIsEditing(true)}
      onBlur={() => setIsEditing(false)}
    />
  );
}
